"use client";

import { FormEvent, useState } from "react";
import { LogIn, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { fetchFromApi } from "@/lib/api";

export default function LocalLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    async function submit(event: FormEvent) {
        event.preventDefault();
        setBusy(true);
        setError("");
        try {
            await fetchFromApi("/api/auth/password/login", {method: "POST", body: JSON.stringify({username, password})});
            window.location.assign("/");
        } catch (e) {
            setError(e instanceof Error ? e.message : "Sign in failed");
            setBusy(false);
        }
    }
    return <main className="mx-auto w-full max-w-sm px-5 py-16">
        <h1 className="mb-8 text-3xl font-semibold">Open Paper</h1>
        <form onSubmit={submit} className="space-y-5">
            <label className="block space-y-2"><span>Account</span><Input autoComplete="username" required value={username} onChange={e => setUsername(e.target.value)} /></label>
            <label className="block space-y-2"><span>Password</span><Input type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} /></label>
            {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Sign in</Button>
        </form>
    </main>;
}
